<template>
  <div class="product-logo">
    <svg-loader src="/assets/images/hotmart-logotype.svg" class="product-logo-image" />

    <div class="product-logo-name">
      hotmart
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ProductLogo',
    props: {
      color: String
    }
  }
</script>

<style lang="scss" scoped>
  @import '~stylesheets/meta';

  .product-logo {
    display: inline-flex;

    .product-logo-image path {
      fill: $brand-primary;
    }
  }

  .product-logo-image {
    width: 20px;
    height: 28px;
  }

  .product-logo-name {
    margin-left: 10px;
    padding-left: 10px;
    font-size: 16px;
    font-weight: bold;
    color: $brand-secondary;

    span {
      display: block;
      font-size: 12px;
      font-weight: 300;
    }
  }
</style>
